<template>
  <div class="sidebar">
    <div class="index">
      <a role="button" class="index-item" v-for="key in keys" :key="key" @click="clickKey(key)">{{ key }}</a>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        keys: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    methods: {
        clickKey(key) {
            this.$emit('click-key', { key });
        },
    },
};
</script>

<style lang="scss" scoped>
.sidebar {
    position: fixed;
    top: 0;
    right: 0;
    width: 8vw;
    height: 100vh;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
}

.index-item {
    display: block;
    width: 6vw;
    line-height: 1.5;
    font-size: 3.2vw;
    color: #7d7d7d;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/trainer/Sidebar.vue